/*
詳しい解説
https://webdesignday.jp/inspiration/technique/jquery-js/3847/
 */
jQuery(function ($){
  $('.js-front-slider').slick({
    slidesToShow: 1,       // 1枚ずつ
    infinite: true,        // 無限ループ
    fade: true,            // フェード切り替え
    cssEase: 'linear',     // フェードは linear が自然
    autoplay: true,        // 自動再生
    autoplaySpeed: 4000,   // 切り替え間隔（ms）
    speed: 800,            // フェードの速さ（ms）
    arrows: false,          // 前後の矢印
    dots: false
  });

  $('.js-front-news').slick({
    slidesToShow: 2,       // 1枚ずつ
    infinite: true,        // 無限ループ
    fade: false,            // フェード切り替え
    autoplay: true,        // 自動再生
    autoplaySpeed: 4000,   // 切り替え間隔（ms）
    speed: 800,            // フェードの速さ（ms）
    arrows: true,          // 前後の矢印
    dots: false
  });


});
